import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Product Name", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "productNameError"
}, null, -1)
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " SKU ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "productSkuError"
}, null, -1)
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Select Type ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "-- Product Type --", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "productTypeError"
}, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "UPC", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "invalid-feedback",
  id: "productUpcError"
}, null, -1)
const _hoisted_22 = {
  key: 1,
  class: "col-md-12 mb-25"
}
const _hoisted_23 = { class: "d-flex mb-15 justify-content-between" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold" }, " Components ", -1)
const _hoisted_25 = { class: "list-group" }
const _hoisted_26 = {
  key: 0,
  class: "list-group-item list-group-item-warning fw-medium fs-md-15"
}
const _hoisted_27 = { class: "d-flex flex-column" }
const _hoisted_28 = { class: "mb-1 fs-md-15 fs-lg-16" }
const _hoisted_29 = { class: "dropdown" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition fs-20 no-after text-paragraph",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1)
const _hoisted_31 = { class: "dropdown-menu" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
  type: "submit"
}
const _hoisted_38 = {
  class: "modal fade",
  id: "addComponentModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_39 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_40 = { class: "modal-content" }
const _hoisted_41 = { class: "modal-header" }
const _hoisted_42 = { class: "modal-title fs-5" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-2" }
const _hoisted_47 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Quantity", -1)
const _hoisted_49 = { class: "col-md-10" }
const _hoisted_50 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Product", -1)
const _hoisted_52 = { class: "modal-footer" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_model_select = _resolveComponent("model-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitCreateOrUpdateProduct && _ctx.submitCreateOrUpdateProduct(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "productName",
                  class: "form-control shadow-none rounded-0 text-black",
                  placeholder: "e.g. Branded Smart Watch",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productName) = $event)),
                  onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateProductName && _ctx.validateProductName(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.productName]
                ]),
                _hoisted_7
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "productSku",
                  class: "form-control shadow-none rounded-0 text-black",
                  placeholder: "e.g. BRAND-S-WATCH",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.productSku) = $event)),
                  onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validateSku && _ctx.validateSku(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.productSku]
                ]),
                _hoisted_11
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select shadow-none fw-semibold rounded-0",
                  name: "productType",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.productType) = $event)),
                  onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.validateProductType && _ctx.validateProductType(...args))),
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validateProductType && _ctx.validateProductType(...args)))
                }, [
                  _hoisted_15,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productTypes, (typeObj) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: typeObj.type,
                      key: typeObj.type
                    }, _toDisplayString(typeObj.name), 9, _hoisted_16))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.productType]
                ]),
                _hoisted_17
              ])
            ]),
            (_ctx.productType == 'simple')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "productUpc",
                      class: "form-control shadow-none rounded-0 text-black",
                      placeholder: "e.g. 850003376356",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.productUpc) = $event)),
                      onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.validateUpc && _ctx.validateUpc(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.productUpc]
                    ]),
                    _hoisted_21
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.productType == 'bundle')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-primary btn-sm position-relative",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#addComponentModal",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addComponentClicked()))
                    }, "Add Product Component")
                  ]),
                  _createElementVNode("ul", _hoisted_25, [
                    (_ctx.components.length == 0)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_26, "Please add product components to the bundle."))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (component) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "list-group-item fw-medium fs-md-15 d-flex justify-content-between",
                        key: component.uid
                      }, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("p", _hoisted_28, _toDisplayString(component.quantity) + " x " + _toDisplayString(component.name), 1),
                          _createElementVNode("small", null, "SKU: " + _toDisplayString(component.sku), 1),
                          _createElementVNode("small", null, "UPC: " + _toDisplayString(component.upc), 1)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("ul", _hoisted_31, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#addComponentModal",
                                class: "dropdown-item d-flex align-items-center",
                                onClick: ($event: any) => (_ctx.editProductComponent(component.uid))
                              }, [
                                _hoisted_33,
                                _createTextVNode(" Edit ")
                              ], 8, _hoisted_32)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center cursor-pointer",
                                onClick: ($event: any) => (_ctx.deleteProductComponent(component.uid))
                              }, [
                                _hoisted_35,
                                _createTextVNode(" Delete")
                              ], 8, _hoisted_34)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", _hoisted_37, _toDisplayString(_ctx.product ? 'Update' : 'Create') + " Product ", 1)
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("h1", _hoisted_42, _toDisplayString(_ctx.updateComponentUid ? 'Edit' : 'Add') + " Product Component", 1),
            _hoisted_43
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "1",
                    class: "form-control shadow-none rounded-0 text-black",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newComponentQty) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newComponentQty]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createVNode(_component_model_select, {
                    class: "form-control shadow-none rounded-0 text-black",
                    placeholder: "e.g. Black Wristband",
                    name: "newComponentUid",
                    modelValue: _ctx.newComponentUid,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newComponentUid) = $event)),
                    options: _ctx.newComponentOptions,
                    onSearchchange: _ctx.updateProductSearch
                  }, null, 8, ["modelValue", "options", "onSearchchange"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addOrUpdateProductComponent && _ctx.addOrUpdateProductComponent(...args))),
              class: "btn btn-outline-primary"
            }, _toDisplayString(_ctx.updateComponentUid ? 'Update' : 'Add'), 1)
          ])
        ])
      ])
    ])
  ], 64))
}